import { violatedPaxRules } from "@/composables/useBookingValidation";

export const passengerValidationTexts = () => violatedPaxRules.map(x => x.text);